<form class="flex flex-col w-full overflow-auto" [formGroup]="ficheInterventionForm" (ngSubmit)="onFormSubmit()">
    <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4">
        <mat-form-field class="w-full">
            <mat-label>Date de contact</mat-label>
            <input type="date" matInput formControlName="date_contact">
        </mat-form-field>
        <mat-form-field class="w-full">
            <mat-label>Date d'intervention</mat-label>
            <input type="date" matInput formControlName="date_intervention">
        </mat-form-field>
    </div>
    <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4">
        <mat-form-field class="w-full">
            <mat-label>Catégorie d'intervention</mat-label>
            <mat-select formControlName="categorie_intervention">
                <mat-option [value]="'Feu'">Feu</mat-option>
                <mat-option [value]="'Eau'">Eau</mat-option>
                <mat-option [value]="'Égout'">Égout</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="w-full">
            <mat-label>Contenu rapporté Urgex</mat-label>
            <input type="text" matInput formControlName="contenu_rapporte_urgex">
        </mat-form-field>
    </div>
    <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4">
        <mat-form-field class="w-full">
            <mat-label>Travaux à effectuer</mat-label>
            <input type="text" matInput formControlName="travaux_a_effectuer">
        </mat-form-field>
        <mat-form-field class="w-full">
            <mat-label>Cause du sinistre</mat-label>
            <input type="text" matInput formControlName="cause_sinistre">
        </mat-form-field>
    </div>
    <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4">
        <mat-form-field class="w-full">
            <mat-label>Recommandations</mat-label>
            <input type="text" matInput formControlName="recommendation">
        </mat-form-field>
        <mat-form-field class="w-full">
            <mat-label>Camion usine</mat-label>
            <input type="text" matInput formControlName="camion_usine" maxlength="5" placeholder="00:00" pattern="^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$" (change)="changeCamionUsine()">
        </mat-form-field>
    </div>
    <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4">
        <mat-form-field class="w-full">
            <mat-label>Débris - Type d'équipement</mat-label>
            <mat-select formControlName="debris_type_equipement_id">
                <mat-option [value]="debrisTypeEquipement.id" *ngFor="let debrisTypeEquipement of debrisTypesEquipements">{{debrisTypeEquipement.type}}</mat-option>
            </mat-select>
            <button type="button" class="ml-4" MatSuffix mat-flat-button [color]="'primary'" (click)="ajouterDebrisTypeEquipement()">
                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
            </button>
        </mat-form-field>
        <mat-form-field class="w-full">
            <mat-label>Débris - Quantité</mat-label>
            <mat-select formControlName="debris_quantite">
                <mat-option [value]="null">Aucune</mat-option>
                <mat-option [value]="'Plein'">Plein</mat-option>
                <mat-option [value]="'Moitié'">Moitié</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4">
        <mat-form-field class="w-full">
            <mat-label>Sacs à ordure</mat-label>
            <input type="number" min="0" matInput formControlName="sacs_ordure">
        </mat-form-field>
        <div class="w-full"></div>
    </div>
    <div class="flex items-center justify-between w-full border-t px-8 py-4" *ngIf="success || error">
        <div class="flex items-center">
            <div class="flex items-center mr-4">
                <ng-container *ngIf="success">
                    <mat-icon class="text-green-500" [svgIcon]="'heroicons_outline:check'"></mat-icon>
                    <span class="ml-2">La fiche de l'intervention a été mise à jour</span>
                </ng-container>
                <ng-container *ngIf="error">
                    <mat-icon class="text-red-500" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                    <span class="ml-2">Erreur lors de l'enregistrement, réessayez!</span>
                </ng-container>
            </div>
        </div>
    </div>
</form>
